navApp.default.factory('NavDataService', [
  '$q', '$http', 'endpointDomain', 'localNavDataUrl', function($q, $http, endpointDomain, localNavDataUrl) {
    // www.qsys.com returns relative paths ("/products-solutions/"); www.qscaudio.com
    // returns absolute URLs. Walk the response and prepend the endpoint host to any
    // root-relative path so links resolve to the marketing site instead of the
    // current WP host. Touches `url`/`image` fields plus href/src attributes inside
    // any HTML-bearing string (e.g. megaDropdownContent).
    var base = endpointDomain.replace(/\/+$/, '');
    function absolutize(node) {
      if (Array.isArray(node)) {
        node.forEach(absolutize);
        return;
      }
      if (!node || typeof node !== 'object') return;
      Object.keys(node).forEach(function(k) {
        var v = node[k];
        if (typeof v === 'string') {
          if ((k === 'url' || k === 'image') && v.charAt(0) === '/') {
            node[k] = base + v;
          } else if (v.indexOf('<') !== -1) {
            node[k] = v.replace(/(href|src)="(\/[^"]*)"/g, function(_, attr, path) {
              return attr + '="' + base + path + '"';
            });
          }
        } else if (v && typeof v === 'object') {
          absolutize(v);
        }
      });
    }
    return {
      // Locally, localNavDataUrl points at a static fixture so the browser
      // doesn't make a cross-origin request to the marketing site.
      getPrimaryNav: _.memoize(function() {
        return this.getFrom(localNavDataUrl || endpointDomain + "?eID=qscnav/navdata/primary&branch=1");
      }),
      getFrom: function(uri) {
        var deferred;
        deferred = $q.defer();
        $http.get(uri).success(function(data) {
          absolutize(data);
          return deferred.resolve(data);
        }).error(function(data, status) {
          console.error("Failed to load nav data from " + uri + " (HTTP " + status + ")");
          return deferred.reject(status);
        });
        return deferred.promise;
      }
    };
  }
]);
